import BaseComponent from './BaseComponent';

class Seeker extends BaseComponent {

    loadOnConstructor(){
	this.handleChange = this.handleChange.bind(this);
	this.searchCallback = this.searchCallback.bind(this);
	this.state = {
		searchValue: ''
	}
    }

    searchCallback(response){
	    if(response.status === 'OK'){
		    this.props.config.setHandler(response);
	    }
    }

    handleChange(event){
	
	this.props.config.handleChangeCallback(event, this.state.searchValue);
	this.setState(prevState => {
		return {
			...prevState,
			searchValue: event.target.value
		}
	});
    }

    render() {
    	return (
    		<div>
			<input type="text" onChange={this.handleChange} placeholder="Buscar..."/>
		</div>
        )
    }

    cursorPointer = {
	cursor:"pointer"
    }
}

export default Seeker;
